import React, { useState } from 'react';

import AdminCardOrderField from '../admin-card-fields/AdminCardOrderField/AdminCardOrderField';
import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';
import ContentChangeButton from '../../buttons/ContentChangeButton/ContentChangeButton';

import './AdminFaqCard.css';

const AdminFaqCard = ({
  faq,
  isButtonsDisabled,
  onEditClickHandler,
  onDeleteClickHandler,
}) => {
  const [open, setOpen] = useState(true);

  return (
    <div className='admin-faq-comp-container'>
      <div className='admin-faq-card-top-container'>
        <AdminCardOrderField>{faq?.order}</AdminCardOrderField>
        <div className='admin-faq-buttons-container'>
          <ContentChangeButton
            iconType='edit'
            isDisabled={isButtonsDisabled}
            onClickHandler={() => onEditClickHandler(faq)}
          />
          <ContentChangeButton
            iconType='delete'
            isDisabled={isButtonsDisabled}
            onClickHandler={() => onDeleteClickHandler(faq)}
          />
        </div>
      </div>

      <div className='admin-faq-quest-comp'>
        <div className='admin-faq-title-edit-delete-container'>
          <div id='admin-greenbox' onClick={() => setOpen(!open)}>
            <div id={open ? 'plus-sign-vert-open' : 'plus-sign-vert'}></div>
            <div id='plus-sign-hort'></div>
          </div>

          <div id='admin-faq-quest-title'>
            <LinkifiedText>{faq?.question || 'loading....'}</LinkifiedText>
          </div>
        </div>
      </div>
      {open && (
        <div id='admin-faq-ans'>
          <LinkifiedText>{faq.answer}</LinkifiedText>
        </div>
      )}
    </div>
  );
};

export default AdminFaqCard;
